import React from "react";
import { ReactSVG } from "react-svg";
import { VisionStudioSvgProps } from "../../types/interface";

/**
 *
 * Reusable component to generate Spinner
 * @param {object} VisionStudioSvgProps
 * @property {string} icon
 * @property {function} handleClick
 * @property {string} id
 * @property {React.CSSProperties} style
 * @property {string} color
 *
 */

const VisionStudioSvg: React.FC<VisionStudioSvgProps> = ({
  icon,
  handleClicked,
  style,
  id,
  color,
}) => {
  return (
    <ReactSVG
      style={style}
      src={icon}
      onClick={(e) => handleClicked && id && handleClicked(e, id)}
      beforeInjection={(svg: SVGSVGElement) => {
        if (svg) {
          const path = svg.querySelector("path");
          if (path) {
            path.setAttribute("fill", color ? color : "#5F6368");
          }
        }
      }}
    />
  );
};

export default VisionStudioSvg;
